import { render, staticRenderFns } from "./TeamMemberCard.vue?vue&type=template&id=3f22ed28&"
import script from "./TeamMemberCard.ts?vue&type=script&lang=ts&"
export * from "./TeamMemberCard.ts?vue&type=script&lang=ts&"
import style0 from "./TeamMemberCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports